import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../../../style';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Select,
  Input,
  CircularProgress
} from '@material-ui/core';
import { Check, CancelOutlined, AddCircleOutline } from '@material-ui/icons';

import validate from 'validate.js';
import schema from './schema';
import { connect } from 'react-redux';
import {
  getUserICD10Codes,
  addUserICD10Code,
  deleteUserICD10Code
} from 'services/icd10/action';

const UserDefined = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      addSelectedICD10,
      deleteSelectedICD10,
      loadUserICD10
    };
  });
  // const UserDefined = props => {
  const { classes, className, userID } = props;
  const [loading, setLoading] = useState(true);
  const [userCode, setUserCode] = React.useState([]);
  const [icdCodeMasterList, setICDCodeMasterList] = React.useState([]);
  const [userICDCode, setUserICDCode] = React.useState([]);
  const [icdUserQuery, setICDUserQuery] = React.useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const initialUserState = {
    code: '',
    description: '',
    keyid: userID,
    isValid: false,
    touched: {},
    errors: {}
  };
  const [values, setValues] = useState(initialUserState);

  useEffect(() => {
    loadUserICD10();
  }, []);

  const loadUserICD10 = () => {
    setLoading(true);
    props.getUserICD10Codes().then(res => {
      if (res && res.data.length > 0) {
        setUserICDCode(res.data);
        setICDCodeMasterList(res.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const addSingleICD10 = () => {
    const codes = [];
    codes.push({
      code: values.code,
      description: values.description,
      keyid: values.keyid
    });
    if (values.isValid) {
      props.addUserICD10Code(codes).then(res => {
        if (res) {
          setEdit();
          props.getUserICD10Codes().then(res => {
            if (res && res.data.length > 0) {
              setICDCodeMasterList(res.data);
              if (icdUserQuery !== '') {
                let searchResult = null;
                searchResult = findICDs(res.data, icdUserQuery);
                setUserICDCode(searchResult);
              } else {
                setUserICDCode(res.data);
              }
            }
          });
          setValues(initialUserState);
        }
      });
    }
  };

  const _handleKeyDown = e => {
    if (e.key === 'Enter') {
      addSingleICD10();
    }
  };

  const handleChange = (field, value) => {
    if (field === 'icdUserQuery') {
      setICDUserQuery(value);
      let searchResult = null;
      searchResult = findICDs(icdCodeMasterList, value);
      setUserICDCode(searchResult);
    } else {
      const newState = { ...values };
      newState[field] = value;
      newState.touched[field] = true;
      const errors = validate(newState, schema);
      newState.errors = errors || {};
      newState.isValid = errors ? false : true;
      setValues(newState);
    }
  };

  const findICDs = (items, text) => {
    text = text.toLowerCase().split(' ');
    return items.filter(function(item) {
      return text.every(function(el) {
        return (
          (item.code && item.code.toLowerCase().indexOf(el) > -1) ||
          (item.description && item.description.toLowerCase().indexOf(el) > -1)
        );
      });
    });
  };

  const handleChangeMultiple = event => {
    const { options } = event.target;
    const value = [];
    const selectedVal = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
        selectedVal.push(
          icdCodeMasterList.filter(
            item => item.id === parseInt(options[i].value)
          )
        );
      }
    }
    setUserCode(value);
    props.setSelectedUserCodes(selectedVal, 'user');
  };

  const deleteSelectedICD10 = async selectedICD10 => {
    if (selectedICD10.length > 0) {
      props.deleteUserICD10Code(selectedICD10).then(res => {
        if (res) {
          props.getUserICD10Codes().then(res => {
            if (res && res.data.length > 0) {
              setUserICDCode(res.data);
              setICDCodeMasterList(res.data);
            }
          });
        }
      });
    }
  };

  const setEdit = () => {
    setIsEdit(!isEdit);
  };

  const addSelectedICD10 = async selectedICD10 => {
    const codes = [];
    codes.push({
      code: values.code,
      description: values.description,
      keyid: values.keyid
    });
    if (selectedICD10.length > 0) {
      props.addUserICD10Code(selectedICD10).then(res => {
        if (res) {
          props.getUserICD10Codes().then(res => {
            if (res && res.data.length > 0) {
              setUserICDCode(res.data);
              setICDCodeMasterList(res.data);
            }
          });
        }
      });
    }
  };

  return (
    <div className={classes.templateWrap}>
      <div className={classes.templateHead}>
        <Typography>User Defined ICD &amp; Descriptions</Typography>
      </div>

      <div className={classes.templateBody}>
        <div style={{ maxHeight: 'calc(100vh - 298px)' }}>
          <Table
            className={classes.templateTable}
            style={{ overflow: 'hidden' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '100%' }}>
                  <TextField
                    className={[classes.textBox, classes.fullWidth]}
                    id="outlined-basic"
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline
                      }
                    }}
                    onChange={event =>
                      handleChange('icdUserQuery', event.target.value)
                    }
                    placeholder="Search user codes and descriptions"
                    value={icdUserQuery}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                  {!isEdit ? (
                    <Button
                      className={classes.addButton}
                      color="primary"
                      onClick={() => setEdit()}
                      size="small"
                      variant="contained">
                      <AddCircleOutline />
                    </Button>
                  ) : (
                    <Button
                      className={classes.addButton}
                      color="primary"
                      onClick={() => setEdit()}
                      size="small"
                      style={{ backgroundColor: '#B9B9B9' }}
                      variant="contained">
                      <CancelOutlined />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            {isEdit ? ( 
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: '100%', whiteSpace: 'nowrap' }}>
                      <TextField
                        className={classes.textBox}
                        id="outlined-basic"
                        InputProps={{
                          classes: {
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        onChange={event =>
                          handleChange('code', event.target.value)
                        }
                        placeholder="Input Code"
                        style={{ width: 80 }}
                        value={values.code}
                        variant="outlined"
                      />
                      <TextField
                        className={classes.textBox}
                        id="outlined-basic"
                        InputProps={{
                          classes: {
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        onChange={event =>
                          handleChange('description', event.target.value)
                        }
                        onKeyPress={_handleKeyDown}
                        placeholder="Input Description"
                        style={{ width: 'calc(100% - 85px)', marginLeft: 5 }}
                        value={values.description}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                      <IconButton
                        color="primary"
                        disabled={!values.isValid}
                        onClick={() => {
                          addSingleICD10();
                        }}
                        size="small"
                        style={{ marginLeft: -15, color: '#03A484' }}>
                        <Check />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead> 
            ) : null}
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  style={{
                    borderColor: 'transparent',
                    height: 'calc(100vh - 400px)'
                  }}>
                  {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CircularProgress size={24} />
                    </div>
                  ) : userICDCode && userICDCode.length > 0 ? (
                    <Select
                      // style={{ maxHeight: '100vh', overflow: 'auto' }}
                      className={classes.multiSel}
                      disabledUnderline
                      input={
                        <Input
                          classes={{
                            underline: classes.underline
                          }}
                        />
                      }
                      inputProps={{ size: '29' }}
                      multiple
                      native
                      onChange={handleChangeMultiple}
                      value={userCode}
                      variant="standard">
                      {userICDCode && userICDCode.length > 0
                        ? userICDCode.map(icdcode => (
                            <option key={icdcode.id} value={icdcode.id}>
                              {icdcode.code} {icdcode.description}
                            </option>
                          ))
                        : null}
                    </Select>
                  ) : (
                    <Typography>
                      No records of user defined ICD &amp; descriptions
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
});

UserDefined.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = {
  getUserICD10Codes,
  addUserICD10Code,
  deleteUserICD10Code
};

const mapStateToProps = state => ({
  userID: state.profile && state.profile.userID,
  userICD10: state.providers && state.icd10.userICD10
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(withStyles(styles)(UserDefined));
